import { STATUS_FORM } from '../constants';

const initialState = {
    requestId: "",

    payload: {}
}

export const statusFormReducer = (state = initialState, action) => {
    const { payload, type } = action;


    switch (type) {
        case STATUS_FORM.STATUS_FORM_DETAILS:
            return {
                ...state,
                requestId: payload.payload.requestId,

                payload: {}
            }
        case STATUS_FORM.STATUS_FORM_SUCCESS:
            return {

                ...payload,
                ...state,
            }
        case STATUS_FORM.RESET_FORM:
            return initialState;
        default:
            return state;
    }
}
export default statusFormReducer;